/**
 *
 * Academy form consent
 *
 */

(function () {
	document.addEventListener('DOMContentLoaded', function () {
		const academySignupFormId = localizedArray.academy_form_id;
		console.log('DOMContentLoaded', academySignupFormId);
		const form = document.querySelector('#gform_' + academySignupFormId);

		if (form) {
			const consentCheckbox = form.querySelector('.ginput_container_consent input[type="checkbox"]');
			const submitButton = form.querySelector('#gform_submit_button_' + academySignupFormId);

			if (consentCheckbox && submitButton) {
				const toggleSubmitButton = () => {
					submitButton.disabled = !consentCheckbox.checked;
				};

				// Initialize the button state
				toggleSubmitButton();

				// Add event listener to consent checkbox
				consentCheckbox.addEventListener('change', toggleSubmitButton);
			}
		}
	});
})();

